import { ChangeEvent, FunctionComponent, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Footer from "../../../components/Footer";
import MostWantedCard from "../../../components/MostWantedCard";
import MultiSelect from "../../../components/MultiSelect";
import ProductCard from "../../../components/ProductCard";
import { ProductServices } from "../../../services/products";
import { useAsync } from "../../../utils/hooks/useAsync";
import Loading from "../../../components/common/Loading";
import { HighlightedSearchesServices } from "../../../services/highlightedSearches";
import useDevice from "../../../utils/hooks/useDevice";
import { ScrollToTopOnMount } from "../../../components/common/ScrollToTopOnMount";
import { Switch } from "../../../components/common/Switch";
import SearchContainer from "../../../components/SearchContainer";

type Props = {};

const SearchPage: FunctionComponent<Props> = ({}) => {
  const { run, isLoading, isSuccess } = useAsync();
  const [subcategoryOptions, setSubcategoryOptions] = useState<
    MultiSelectOption[]
  >([]);

  useEffect(() => {
    run(
      ProductServices.getCategoriesbyDepartment("").then((r) => {
        setSubcategoryOptions(r.data);
      })
    );
  }, []);

  return (
    <>
      <ScrollToTopOnMount />
      {isLoading && <Loading />}
      {subcategoryOptions.length > 1 && (
        <SearchContainer subcategoryOptions={subcategoryOptions} />
      )}
      <Footer />
    </>
  );
};

export default SearchPage;
